// extracted by mini-css-extract-plugin
export const contentWrapper = "project-modules--contentWrapper--Yby9B";
export const nextProjectPlaceholder = "project-modules--nextProjectPlaceholder--1epzJ";
export const nextProjectLink = "project-modules--nextProjectLink--2Bp0y";